import { Anchor, Button, Stack, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "../components/AuthShell";
import { PASSWORD_RESET_COPY } from "../constants/account";
import { AUTH_PATHS } from "../constants/publicUrls";
import { authApi } from "../lib/api";
import { ApiError } from "../lib/apiClient";
import { axioTokens } from "../theme";

export function ForgotPasswordPage() {
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const form = useForm({
    initialValues: { email: "" },
    validate: {
      email: (v) => (/^\S+@\S+\.\S+$/.test(v) ? null : "Enter a valid email"),
    },
  });

  async function handleSubmit(values: typeof form.values) {
    setSubmitting(true);
    try {
      await authApi.forgotPassword(values.email);
      setSent(true);
    } catch (err) {
      notifications.show({
        color: "red",
        title: PASSWORD_RESET_COPY.forgotTitle,
        message: err instanceof ApiError ? err.message : "Could not send a reset link",
      });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell title={PASSWORD_RESET_COPY.forgotTitle} subtitle={PASSWORD_RESET_COPY.forgotSubtitle}>
      {sent ? (
        <Stack gap={axioTokens.unit[32]}>
          <Text>{PASSWORD_RESET_COPY.forgotSentBody}</Text>
          <Anchor component={Link} to={AUTH_PATHS.login}>
            {PASSWORD_RESET_COPY.backToLogin}
          </Anchor>
        </Stack>
      ) : (
        <form onSubmit={form.onSubmit(handleSubmit)}>
          <Stack gap="md">
            <TextInput label="Email address" required {...form.getInputProps("email")} />
            <Button type="submit" loading={submitting}>
              {PASSWORD_RESET_COPY.forgotCta}
            </Button>
            <Anchor component={Link} to={AUTH_PATHS.login}>
              {PASSWORD_RESET_COPY.backToLogin}
            </Anchor>
          </Stack>
        </form>
      )}
    </AuthShell>
  );
}
